import moment from "moment";

/**
 * Check if an interview schedule is within 30 minutes of the current time
 * @param interviewSchedule - ISO 8601 datetime string (e.g., "2026-02-05T07:00:00.000000Z")
 * @returns boolean - true if interview is within 30 minutes (past or future) of current time
 */
export const isInterviewWithin30Minutes = (interviewSchedule: string | undefined): boolean => {
  if (!interviewSchedule) return false;

  const now = moment();
  const interviewTime = moment.utc(interviewSchedule).local();
  const diffInMinutes = interviewTime.diff(now, "minutes");

  // Check if interview is within 30 minutes (past or future)
  return Math.abs(diffInMinutes) <= 30;
};

/**
 * Check if an interview can be started (within 5 minutes of schedule time)
 * Button should be enabled only when interview is within 5 minutes
 * @param interviewSchedule - ISO 8601 datetime string (e.g., "2026-02-05T07:00:00.000000Z")
 * @returns boolean - true if interview is within 5 minutes (before or after) of current time
 */
export const canStartInterview = (interviewSchedule: string | undefined): boolean => {
  if (!interviewSchedule) return false;

  const now = moment();
  const interviewTime = moment.utc(interviewSchedule).local();
  const diffInMinutes = interviewTime.diff(now, "minutes");

  // Enable button only within 5 minutes before or after the scheduled time
  // diffInMinutes will be positive if interview is in future, negative if in past
  // return diffInMinutes >= -5 && diffInMinutes <= 5;
  return diffInMinutes < 5;
};
